import { Link } from "react-router-dom";
import { LogIn, LogOut, LayoutDashboard } from "lucide-react";
import { Button } from "../ui/button";

export function DesktopNav({ links, pathname, onNav }) {
  return (
    <div className="hidden md:flex items-center gap-8">
      {links.map((link) => (
        <button
          key={link.label}
          data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
          onClick={() => onNav(link)}
          className={`font-outfit text-sm font-medium transition-colors duration-200 ${link.isRoute && pathname === link.href ? "text-ib-blue" : "text-ib-text-secondary hover:text-ib-blue"}`}
        >
          {link.label}
        </button>
      ))}
    </div>
  );
}

export function UserMenu({ user, onLogout }) {
  if (!user) {
    return (
      <Link to="/login" data-testid="nav-login-btn">
        <Button variant="outline" className="hidden md:inline-flex border-ib-steel/50 text-ib-text-secondary hover:text-ib-lime hover:border-ib-lime/50 font-outfit text-sm transition-all duration-200 gap-1.5">
          <LogIn className="w-3.5 h-3.5" /> Login
        </Button>
      </Link>
    );
  }
  return (
    <div className="hidden md:flex items-center gap-2">
      {user.role === "admin" && (
        <Link to="/admin" data-testid="nav-admin-link">
          <Button variant="ghost" size="sm" className="text-ib-lime hover:text-ib-lime font-outfit text-xs gap-1.5">
            <LayoutDashboard className="w-3.5 h-3.5" /> Admin
          </Button>
        </Link>
      )}
      <span data-testid="nav-user-name" className="font-jetbrains text-xs text-ib-text-secondary">{user.name || user.email}</span>
      <Button data-testid="nav-logout-btn" onClick={onLogout} variant="ghost" size="sm" className="text-ib-text-secondary hover:text-ib-negative font-outfit text-xs gap-1.5">
        <LogOut className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
}
